import { createContext, useContext } from "react";

interface ModalAriaContextValue {
  setLabelledById: (id: string) => void;
}

const ModalAriaContext = createContext<ModalAriaContextValue | null>(null);

export const ModalAriaContextProvider = ModalAriaContext.Provider;

export const useModalAriaContext = () => {
  const context = useContext(ModalAriaContext);

  return (
    context ?? {
      setLabelledById: () => {},
    }
  );
};
